import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Pages from '../Context/Pages';

import Home from '../Pages/Home/Home';
import About from '../Pages/About/About';
import Services from '../Pages/Services/Services';
import Team from '../Pages/Team/Team';
import Individual from '../Pages/Individual/Individual';
import Contact from '../Pages/Contact/Contact';
import Error from '../Pages/Error';

function getPage() {
  return (
    <Router>
      <Switch>
        <Route exact path={Pages.Home}>
          <Home />
        </Route>

        <Route exact path={Pages.About}>
          <About />
        </Route>

        <Route exact path={Pages.Services}>
          <Services />
        </Route>

        <Route exact path={Pages.Team}>
          <Team />
        </Route>

        <Route path={`${Pages.Team}/:individual`}>
          <Individual />
        </Route>

        <Route exact path={Pages.Contact}>
          <Contact />
        </Route>

        <Route>
          <Error />
        </Route>
      </Switch>
    </Router>
  )
}

export default getPage;